import { Divider, Stack, Typography } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { AuthApi, InvitationApi } from "certiblok-api-manager";
import { useTranslation } from "react-i18next";
import LoadingIconButton from "../../../utils/components/buttons/LoadingIconButton";
import { instanceApi, useApi } from "../../../utils/hooks/api";

const SocialLoginButtons = ({ invitationToken }: { invitationToken?: string }) => {
	const { t } = useTranslation();
	const authApi = useApi(AuthApi);

	const { mutate: handleGoogleLogin, isLoading: isGoogleLoading } = useMutation({
		mutationFn: async () => {
			if (invitationToken) {
				await instanceApi(InvitationApi).reviewInvitation({
					token: invitationToken,
					accepted: true,
				});
			}
			return authApi.getGoogleAuthUrl("login");
		},
		onSuccess: (res) => {
			window.location.replace(res.data);
		},
	});

	const { mutate: handleMicrosoftLogin, isLoading: isMicrosoftLoading } = useMutation({
		mutationFn: async () => {
			if (invitationToken) {
				await instanceApi(InvitationApi).reviewInvitation({
					token: invitationToken,
					accepted: true,
				});
			}
			return authApi.getMicrosoftAuthUrl("login");
		},
		onSuccess: (res) => {
			window.location.replace(res.data);
		},
	});

	return (
		<Stack spacing={2} sx={{ width: "100%" }}>
			<div className="flex items-center gap-2 w-full justify-center py-2 pb-4">
				<Divider className="flex-1" />
				<Typography
					variant="body2"
					sx={{
						color: "text.secondary",
					}}
					className="uppercase"
				>
					{t("login.orContinueWith")}
				</Typography>
				<Divider className="flex-1" />
			</div>
			<LoadingIconButton
				variant="outlined"
				fullWidth
				onClick={() => handleMicrosoftLogin()}
				loading={isMicrosoftLoading}
				icon={
					<img
						src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Microsoft_logo.svg/2048px-Microsoft_logo.svg.png"
						alt="Microsoft"
						width="18"
						height="18"
					/>
				}
				sx={{
					textTransform: "none",
					height: 48,
					borderColor: "divider",
					"&:hover": {
						borderColor: "divider",
						backgroundColor: "action.hover",
					},
				}}
			>
				{t("login.continueWithMicrosoft")}
			</LoadingIconButton>
			<LoadingIconButton
				variant="outlined"
				fullWidth
				onClick={() => handleGoogleLogin()}
				loading={isGoogleLoading}
				icon={
					<img
						src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
						alt="Google"
						width="18"
						height="18"
					/>
				}
				sx={{
					textTransform: "none",
					height: 48,
					borderColor: "divider",
					"&:hover": {
						borderColor: "divider",
						backgroundColor: "action.hover",
					},
				}}
			>
				{t("login.continueWithGoogle")}
			</LoadingIconButton>
		</Stack>
	);
};

export default SocialLoginButtons;
